import React, { useState, useRef, useEffect } from 'react'
import { withLanguage } from '~src/LanguageContext'
import Icon from '@material-ui/core/Icon'

const LanguageSelector = ({
  supportedLanguages,
  selectedLanguage,
  onLanguageChange,
  className = '',
}) => {
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)
  useEffect(() => {
    if (open) {
      document.body.classList.add('language-dropdown-open')
    } else {
      document.body.classList.remove('language-dropdown-open')
    }

    return () => document.body.classList.remove('language-dropdown-open')
  }, [open])

  const handleClickOutside = e => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelect = lang => {
    onLanguageChange && onLanguageChange(lang)
    setOpen(false)
  }

  if (!selectedLanguage) return null

  return (
    <div className={`relative ${className}`} ref={wrapperRef}>
      <div
        className="flex cursor-pointer items-center rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-sm transition"
        onClick={() => setOpen(!open)}
      >
        <span className="flex-grow truncate text-sm font-medium">
          {selectedLanguage.labelShort} {selectedLanguage.label}
        </span>
        <Icon className="ml-2 flex !h-3.5 !w-3.5 items-center justify-center text-base leading-none text-gray-700">
          {open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
        </Icon>
      </div>

      {open && (
        <div className="bg-paper absolute right-0 z-[1001] mt-2 w-full overflow-hidden rounded-lg border border-gray-300 shadow-md">
          {supportedLanguages.map(lang => (
            <div
              key={lang.id}
              onClick={() => handleSelect(lang)}
              className="cursor-pointer px-2 py-2 text-sm first:rounded-t-lg last:rounded-b-lg hover:bg-gray-100"
            >
              {lang.labelShort} {lang.label}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default withLanguage(LanguageSelector)
